import "core-js/modules/es.array.concat";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Ritika Khare
 */
import globals from '../../lib/globals/globals';
import getJson from '../../lib/network/get-json';
import { keepAlive, closeEvent, samlDataResponse, getNavigationItem } from './nuance-event-handlers';
import { requestNavigation } from '../../lib/store/navigation/actions';
import logger from '../../lib/logger/logger';
export default (function (initChatInfo, menuClick, dispatch) {
  var c2c = new window.BootStrapC2C({});
  window.WF_NUANCE.UUID = initChatInfo.UUID;
  window.WF_NUANCE = window.WF_NUANCE || {};

  window.WF_NUANCE.handleNavigation = function (param) {
    var _ref = param || {},
        displayType = _ref.displayType;

    if (displayType === 'saml') {
      getJson({
        url: "".concat(globals().messengerWebSDK.wfNuanceWebSDKChatUrl, "&implementationName=call_to_action&identifier=").concat(param.identifer),
        includeRootContext: false
      }).then(function (response) {
        var navigationItem = getNavigationItem(response);
        dispatch(requestNavigation(navigationItem));
      })["catch"](function (err) {
        logger.error('Failed to load navigation configuration for nuance', err);
      });
    } else if (displayType === 'dialNumber') {
      window.location.href = "tel:".concat(param.phoneNumber);
    } else {
      var navigationItem = getNavigationItem(param);
      dispatch(requestNavigation(navigationItem));
    }
  };

  window.WF_NUANCE.samlDataRequest = function (chatParams) {
    getJson({
      url: "".concat(globals().messengerWebSDK.wfNuanceWebSDKChatUrl, "&implementationName=saml&").concat(chatParams),
      includeRootContext: false
    }).then(function (result) {
      samlDataResponse(result, window.WF_NUANCE.UUID);
    })["catch"](function (err) {
      logger.error('Could not get SAML data request', err);
    });
  };

  NuanMessaging.initializeMessagingSDK('west', 'tagserverv3', window.WF_NUANCE.UUID, function () {
    NuanMessaging.getAndSetSDKConfig().setPageData('WF_NUANCE', {
      nuanceMenuItemClicked: "".concat(menuClick),
      nuanceData: initChatInfo,
      customerToken: initChatInfo.hashedecn ? initChatInfo.hashedecn : globals().hashedecn
    });
    NuanMessaging.getAndSetSDKConfig().overrideTagDomain(globals().messengerWebSDK.tagDomain);

    if (typeof NuanMessaging.getAndSetSDKConfig().enableC2CPluginForMinimizedState === 'function') {
      NuanMessaging.getAndSetSDKConfig().enableC2CPluginForMinimizedState(c2c);
    } else {
      NuanMessaging.getAndSetSDKConfig().enableCustomC2CRendering(c2c);
    }

    NuanMessaging.getAndSetSDKConfig().setFrameConfig(350, 500);
    NuanMessaging.loadChatAssets(true);
    NuanMessaging.getAndSetSDKConfig().registerForMessagingEvents(NuanMessaging.getAndSetSDKConfig().Events.ON_CUSTOMER_MSG, keepAlive);
    NuanMessaging.getAndSetSDKConfig().registerForMessagingEvents(NuanMessaging.getAndSetSDKConfig().Events.ON_AGENT_MSG, keepAlive);
    NuanMessaging.getAndSetSDKConfig().registerForMessagingEvents(NuanMessaging.getAndSetSDKConfig().Events.ON_CHAT_CLOSED, function () {
      return closeEvent(dispatch);
    });
  });
});